<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Pracownicy</span>
        <h3 class="page-title">Dodawanie nowego pracownika</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/pracownicy')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button theme="success" @click.prevent="validateForm">
          <i class="material-icons">add</i>
          Dodaj pracownika
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>
            <d-row>
              <d-col>
                <validation-observer ref="worker-new-form" tag="form">
                  <div class="form-group">
                    <label for="name_surname">
                      Imię i nazwisko:
                    </label>

                    <validation-provider
                            rules="required"
                            name="name_surname"
                            v-slot="{ errors }">
                      <d-input
                              :state="errors.length ? 'invalid' : null"
                              id="name_surname"
                              v-model="worker.name_surname" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>

                  <div class="form-group">
                    <label for="phone">
                      Telefon:
                    </label>

                    <validation-provider
                            name="phone"
                            v-slot="{ errors }">
                      <d-input
                              :state="errors.length ? 'invalid' : null"
                              id="phone"
                              v-model="worker.phone" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>

                  <div class="form-group">
                    <label for="email">
                      E-mail:
                    </label>

                    <validation-provider
                            rules="required|email"
                            name="email"
                            v-slot="{ errors }">
                      <d-input
                              :state="errors.length ? 'invalid' : null"
                              type="email"
                              id="email"
                              v-model="worker.email" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>

                  <div class="form-group">
                    <label for="position">
                      Stanowisko:
                    </label>

                    <validation-provider
                            rules="required"
                            name="position"
                            v-slot="{ errors }">
                      <d-input
                              :state="errors.length ? 'invalid' : null"
                              type="text"
                              id="position"
                              v-model="worker.position" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>

                  <div class="form-group">
                    <validation-provider
                            name="color_id"
                            v-slot="{ errors }">
                      <label>Firma:</label>
                      <div :class="{ 'form-control': true, 'is-select': true }">
                        <v-select
                                style="width: 360px;"
                                class="ss-custom-select"
                                :options="colorOptions"
                                :reduce="color => color.value"
                                v-model="worker.color_id"
                                placeholder="Firma"
                                :searchable="false"
                                label="value">
                          <template slot="option" slot-scope="data">
                            <div :style="{borderLeftColor: data.color}" class="color-option">{{ data.text }}</div>
                          </template>
                          <template slot="selected-option" slot-scope="data">
                            <div :style="{borderLeftColor: data.color}" class="color-selected">{{ data.text }}</div>
                          </template>
                        </v-select>
                      </div>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>

                  <div class="form-group">
                    <file-input
                            class="form-group"
                            id="uploaded_file2"
                            accept=".jpg, .png, .gif"
                            ref="uploadRef"
                            hidden
                            :onChange="croppie" />
                  </div>

                </validation-observer>
              </d-col>
              <d-col>
                <d-row>
                  <d-col cols="12" md="3">
                    <div class="form-group">
                      <label>Zdjęcie:</label>
                      <img v-bind:src="croppieImage ? croppieImage : worker.path2_url "
                           v-if="worker.path2_url || croppieImage"
                           class="preview-image"
                           :style="{
                           'height': croppieViewport.height + 'px',
                           'width': croppieViewport.width + 'px'
                           }">
                      <div class="avatar-placeholder" v-else>
                        Brak zdjęcia
                      </div>
                    </div>
                  </d-col>
                  <d-col cols="12" md="9">
                    <div class="croppie-wrapper">
                      <vue-croppie
                              ref="croppieRef"
                              :enableOrientation="true"
                              :boundary="{ width: 200, height: 200}"
                              :viewport="croppieViewport"
                              :enableResize="false"
                              @result="result">
                              sss
                      </vue-croppie>

                    <div
                      v-if="fileSizeError"
                      class="text-danger small mb-2 text-center"
                      style="font-size: 0.8rem; margin-top: -1rem;"
                    >
                      {{ fileValidationError || 'Plik jest zbyt duży. Maksymalny rozmiar to 4MB. Wybierz mniejszy plik.' }}
                    </div>

                      <div class="text-center d-flex justify-content-center align-items-center">
                        <d-button @click.prevent="crop()" theme="success" class="m-2" v-if="fileLoaded">Zapisz zdjęcie</d-button>
                        <d-button @click.prevent="uploadFile()" class="m-2">Załaduj zdjęcie</d-button>
                      </div>


                    </div>
                  </d-col>
                </d-row>
              </d-col>
            </d-row>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import SanitizeUtils from './../../utils/SanitizeUtils';
import ColorUtils from './../../utils/ColorUtils';
import FileUtils from './../../utils/FileUtils';

export default {
  name: 'worker-new',
  data() {
    return {
      worker: {
        name_surname: '',
        email: '',
        position: '',
        phone: '',
        color_id: 0,
        path2: null,
        path2_url: null
      },
      colorOptions: [],
      cropped: null,
      croppieImage: null,
      fileLoaded: false,
      fileSizeError: false,
      fileValidationError: ''
    };
  },
  computed: {
    croppieOptions() {
      let size = 92;
      if (this.croppieViewport.type === 'circle') {
        size = 107;
      }
      const circle = this.croppieViewport.type === 'circle'
      const options = {
        type: 'base64',
        format: 'jpeg',
        size,
        circle
      }

      return options
    },
    croppieViewport() {
      return {
        width: 107,
        height: 107,
        type: 'square'
      }
    }
  },
  async mounted () {
    try {
      await SanitizeUtils.checkPermissions(this)
      this.colorOptions = await ColorUtils.getColorOptions(this)
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['worker-new-form'], this.submitForm);
    },
    submitForm () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/workers/store',
        formData: this.worker,
        successTitle: 'Dodano pracownika',
        successText: 'Podany pracownik został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Dodawanie pracownika nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/pracownicy')
        }
      });
    },
    croppie (e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      const file = files[0];

      // validate file
      const validation = FileUtils.validateImageFile(file);
      if (!validation.isValid) {
        this.fileSizeError = true;
        this.fileValidationError = validation.error;
        this.fileLoaded = false;
        // clear input file
        e.target.value = '';
        return;
      }

      // hide error if it was displayed
      this.fileSizeError = false;
      this.fileValidationError = '';

      const reader = new FileReader();
      reader.onload = (event) => {
        this.fileLoaded = true
        this.$refs.croppieRef.bind({
          url: event.target.result
        });
      };

      reader.readAsDataURL(file);
    },
    crop() {
      this.$refs.croppieRef.result(this.croppieOptions, output => {
        this.cropped = output
        this.croppieImage = output
        this.axios.post('/workers/upload-image', {
          upload: output,
          type: this.croppieViewport.type,
          imgsize: this.croppieOptions.size
        }).then(response => {
          if (response.data.fileUploaded) {
            this.worker.path2 = response.data.filename
          }
        }).catch(error => {
          console.log(error);
        });
      });
    },
    result(output) {
      this.cropped = output;
    },
    uploadFile() {
      this.$refs.uploadRef.$el.querySelector('input').click()
    }
  },
  watch: {
    croppieOptions: {
      deep: true,
      handler(from, to) {
        if (from.size !== to.size || from.circle !== to.circle) {
          this.$nextTick(function () {
            this.$refs.croppieRef.refresh()
            this.$forceUpdate()
          })
        }
      }
    }
  }
};
</script>

<style>
  .preview-image{
    max-width: 120px;
    max-height: 120px;
    display: block;
  }
  .avatar-placeholder{
    width: 120px;
    height: 120px;
    background-color: #eaeaea;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .croppie-wrapper {
    margin-top: 30px;
  }
</style>
